/* Tiny Magnet Studio theme scripts */
(function () {
  // Pack size picker: update price, compare price, sale tag, button and URL.
  document.addEventListener('change', function (event) {
    var input = event.target.closest ? event.target.closest('[data-variant-input]') : null;
    if (!input) return;
    var root = input.closest('[data-product]');
    if (!root) return;

    var price = root.querySelector('[data-price]');
    var compare = root.querySelector('[data-compare-price]');
    var saleTag = root.querySelector('[data-sale-tag]');
    var selected = root.querySelector('[data-selected-option]');
    var button = root.querySelector('[data-add-button]');

    if (price) price.textContent = input.dataset.price;
    if (compare) {
      compare.textContent = input.dataset.compare || '';
      compare.hidden = !input.dataset.compare;
    }
    if (saleTag) saleTag.hidden = !input.dataset.compare;
    if (selected) selected.textContent = input.dataset.title;
    if (button) {
      var available = input.dataset.available === 'true';
      button.disabled = !available;
      button.textContent = available ? button.dataset.addText : button.dataset.soldText;
    }

    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', input.value);
      window.history.replaceState({}, '', url.toString());
    } catch (e) {}
  });

  // Product gallery thumbnails.
  document.addEventListener('click', function (event) {
    var thumb = event.target.closest ? event.target.closest('[data-thumb]') : null;
    if (!thumb) return;
    var gallery = thumb.closest('[data-gallery]');
    if (!gallery) return;
    var index = thumb.getAttribute('data-thumb');
    gallery.querySelectorAll('[data-slide]').forEach(function (slide) {
      slide.hidden = slide.getAttribute('data-slide') !== index;
    });
    gallery.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
    });
  });
})();
